import React from 'react';
import './logo.css';

function Logo() {
  const handleToggleSideBar = () => {
    document.body.classList.toggle('toggle-sidebar');
  };

  return (
    <div className="d-flex align-items-center justify-content-between">
      <a href="/public" className="logo d-flex align-items-center">
        <img src="https://688ebff5991a6a07d8deaedd2b3b3eee.cdn.bubble.io/f1708579109744x523754866786500860/mor.svg" alt="MOR" />
      </a>
      <i
        className="bi bi-list toggle-sidebar-btn icon-style"
        onClick={handleToggleSideBar}
      ></i>
    </div>
  );
}

export default Logo;
